import classNames from 'classnames';
import { memo, useMemo } from 'react';
import { CustomTextAreaProps } from '../../interfaces';
import '../../styles.scss';
import { createNewWidthHeightStyle } from '../../utils';
import { CustomTextArea } from './styles';
import './styles.scss';

const CustomTextAreaInput: React.FC<CustomTextAreaProps> = props => {
  const { width, height, className, style = {}, onChange, ...rest } = props;

  const newStyle = useMemo(() => {
    return { ...style, ...createNewWidthHeightStyle({ width, height }) };
  }, [width, height, style]);

  const newClassName = classNames(className, 'custom-text-area');

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(
      className?.includes('controlledInput') ? (e.target.value as any) : e,
    );
  };

  const customProps: { onChange?: typeof handleChange } = {};
  if (onChange) customProps.onChange = handleChange;

  return (
    <CustomTextArea
      {...rest}
      {...customProps}
      style={newStyle}
      className={newClassName}
    />
  );
};

export default memo(CustomTextAreaInput);
